import initialState from '../initialState.js';
import {
    BANKING_DETAILS_VERIFYING,
    GET_ADVISOR_SUCCESS,
    GET_ADVISORS_SUCCESS,
    CREATE_ADVISOR_SUCCESS,
    UPDATE_ADVISOR_SUCCESS,
    REMOVE_NOTIFICATION_SUCCESS,
    GET_SPECIFIC_ADVISOR_ACCOUNTS_SUCCESS,
    SET_AFFILIATE_LINK
} from '../../actions/types/advisors';

export default (state = initialState.advisors, action) => {
    switch (action.type) {
        case BANKING_DETAILS_VERIFYING: {
            return {
                ...state,
                bankingDetailsVerifying: action.state
            };
        }

        case GET_SPECIFIC_ADVISOR_ACCOUNTS_SUCCESS: {
            const accounts = state.currentAdvisor.accounts ? [ ...state.currentAdvisor.accounts ] : [];

            return {
                ...state,
                currentAdvisor: {
                    ...state.currentAdvisor,
                    accounts: action.shouldAppend ? [ ...accounts, ...action.accounts ] : [ ...action.accounts ],
                    cursor: action.cursor
                }
            };
        }

        case GET_ADVISORS_SUCCESS: {
            const advisors = state.list ? [ ...state.list ] : [];

            return {
                ...state,
                list: action.shouldAppend ? [ ...advisors, ...action.advisors ] : [ ...action.advisors ],
                cursor: action.cursor
            };
        }

        case GET_ADVISOR_SUCCESS: {
            return {
                ...state,
                currentAdvisor: {
                    ...action.advisorMeta,
                    quotes: action.quotes,
                    accounts: action.accounts,
                    cursor: action.cursor,
                    specialityProductMetaConfigs: action.specialityProductMetaConfigs
                }
            };
        }

        case CREATE_ADVISOR_SUCCESS: {
            return {
                ...state,
                list: [ ...state.list, action.advisor ]
            };
        }

        case UPDATE_ADVISOR_SUCCESS: {
            return {
                ...state,
                currentAdvisor: { ...state.currentAdvisor, ...action.advisorMeta }
            };
        }

        case REMOVE_NOTIFICATION_SUCCESS: {
            return {
                ...state,
                currentAdvisor: {
                    ...state.currentAdvisor,
                    notifications: state.currentAdvisor.notifications.filter((item) => item.id !== action.id)
                }
            };
        }

        case SET_AFFILIATE_LINK: {
            return {
                ...state,
                currentAdvisor: {
                    ...state.currentAdvisor,
                    marketplaceAffiliateLink: action.marketplaceAffiliateLink
                }
            };
        }

        default:
            return state;
    }
};